import { YoutubeSearchedFor } from "@mui/icons-material";
import { Button, Card, CardActions, CardContent, Link, Tooltip } from "@mui/material/";
import { useContext } from "react";
import { SearchContext } from "../../contexts/SearchContext";
import { IMaterialItem, ISearchHistory } from "../../interfaces";
import { EmptyContent } from "./EmptyContent";
import './index.scss';
import { WidgetHeader } from "./WidgetHeader";

export const RecentSearchWidget: React.FC<{ expanded?: boolean }> = ({
    expanded
}) => {

    const searchContext = useContext(SearchContext);

    const hasHistory = () => {
        return searchContext.history.length > 0
    }

    const onSearch = (historyItem: ISearchHistory) => {

        searchContext.search(true, historyItem.keywords);
    }

    const formatLabel = (keywords: IMaterialItem[]) => {
        let labelParts: string[] = [];

        keywords.forEach((key: IMaterialItem) => {

            if (!key.value) return;


            let value = key.value;

            //if value is a date, format as DD/MM/YYYY
            if (Number.isInteger(Date.parse(key.value)) && key.id == null)
                value = new Date(value).toLocaleDateString("en-GB");



            if (key.id == null) {
                if (key.propertyName == null) labelParts.push(value);
                else labelParts.push(`${key.propertyName} : ${value}`)
            } else labelParts.push(value);

        });

        return labelParts.join(", ");

    }

    return (
        <Card elevation={3} className="dashboard-widget" style={expanded ? { height: "100%" } : { maxHeight: '300px' }}>
            <WidgetHeader><YoutubeSearchedFor sx={{ mr: 1 }} /> Recent Searches</WidgetHeader>
            <CardContent sx={{ height: "calc(100% - 5.5em)", overflowY: hasHistory() ? "auto" : "none", scrollbarWidth: "thin" }}>
                {hasHistory() ?
                    <ul className="widget-list">
                        {searchContext.history.map((h, i) => {

                            const label = formatLabel(h.keywords);

                            return <li key={i}>
                                <Tooltip title={label}>
                                    <Link onClick={() => onSearch(h)} href="#">{label}</Link>
                                </Tooltip>
                            </li>
                        })}
                    </ul>
                    :

                    <EmptyContent
                        contentType="recent searches"
                        icon={<YoutubeSearchedFor fontSize="inherit" />}
                    />
                }

            </CardContent>
            <CardActions>
                <Button
                    variant="text"
                    color="warning"
                    size="small"
                    onClick={searchContext.clearHistory}
                    disabled={!hasHistory()}
                >Clear</Button>
            </CardActions>
        </Card >
    );

}